import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { MousePointerClick, ScanLine, ListChecks, Repeat, MapPin } from "lucide-react";

interface BinHelpModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function BinHelpModal({ open, onOpenChange }: BinHelpModalProps) {
  const { t } = useTranslation("harvest");

  const items = [
    {
      icon: MousePointerClick,
      title: t("process.binHelp.manualTitle"),
      body: t("process.binHelp.manual"),
    },
    {
      icon: ListChecks,
      title: t("process.binHelp.multiTitle"),
      body: t("process.binHelp.multi"),
    },
    {
      icon: ScanLine,
      title: t("process.binHelp.scannerTitle"),
      body: t("process.binHelp.scanner"),
    },
    {
      icon: Repeat,
      title: t("process.binHelp.scannerMultiTitle"),
      body: t("process.binHelp.scannerMulti"),
    },
    {
      icon: MapPin,
      title: t("process.binHelp.changeTitle"),
      body: t("process.binHelp.change"),
    },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{t("process.binHelpTitle")}</DialogTitle>
          <DialogDescription>{t("process.binHelpSubtitle")}</DialogDescription>
        </DialogHeader>
        <div className="mt-2 space-y-4">
          {items.map((item) => (
            <div key={item.title} className="flex gap-3">
              <div className="mt-0.5 shrink-0 w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                <item.icon className="w-4 h-4 text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{item.title}</p>
                <p className="text-sm text-muted-foreground leading-relaxed">{item.body}</p>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
